import { SIGNEDHUMAN_API } from '@app/utils/apiUrl';
import { messageToast, status200 } from '@app/utils/define';
import { Post } from '@app/utils/httpProvider';
import moment from 'moment';
import { toast } from 'react-toastify';

const handleExport = async (values) => {
    const model = { ...values };

    try {
        const res = await Post(SIGNEDHUMAN_API.EXPORT_PDF, null, model, false, false, true);
        if (res && res.data && res.data.length === 0) {
            toast.error("Đã có lỗi xảy ra khi xuất biểu mẫu Phụ lục 2 (Word), vui lòng thử lại!");
        } else {
            toast.success("Xuất biểu mẫu Phụ lục 2 (Word) thành công!");
        }

        var data = res.data;
        var filePath = data[0].savePath;

        return filePath;
    } catch (error) {
        toast.error(error?.message || 'Đã có lỗi xảy ra, vui lòng thử lại !');
    }
};

/**
 * Xuất biểu mẫu Phụ lục 2 (Cấp chứng nhận CME) dưới định dạng file Word (.doc)
 * Sử dụng định dạng HTML-to-Word kèm thiết lập trang nằm ngang (Landscape) và Font chữ chuẩn.
 * 
 * @param {Array} recordList Danh sách học viên điểm danh
 * @param {Object} eventData Thông tin lớp học/khóa đào tạo
 * @param {string} filePath Đường dẫn file Word mẫu
 */
export const exportToWordPhuLuc2 = async (recordList, eventData, filePath) => {
    if (!recordList || recordList.length === 0) {
        toast.warning("Không có dữ liệu để xuất.");
        return;
    }

    if (!eventData) {
        toast.error("Thiếu thông tin khóa đào tạo.");
        return;
    }

    // Tạo cấu trúc bảng HTML hàng loạt
    let tableRows = "";

    var lstExport = [];
    recordList.forEach((item, idx) => {
        // Lấy thông tin từ các span/cell tương ứng đã render trên màn hình
        const nameEl = document.getElementById(`name-${item.userId}`);
        const cccdEl = document.getElementById(`cccd-${item.userId}`);
        const unitEl = document.getElementById(`unit-${item.userId}`);

        const fullName = nameEl ? nameEl.innerText.trim() : "Đang tải...";
        const cccd = cccdEl ? cccdEl.innerText.trim() : "-";
        const unit = unitEl ? unitEl.innerText.trim() : "-";

        // tableRows += `
        //     <tr>
        //         <td style="text-align: center; border: 1px solid #000000; padding: 6px; vertical-align: middle;">${idx + 1}</td>
        //         <td style="border: 1px solid #000000; padding: 6px; vertical-align: middle; mso-number-format:'\\@';">${cccd}</td>
        //         <td style="border: 1px solid #000000; padding: 6px; vertical-align: middle;">${fullName}</td>
        //         <td style="border: 1px solid #000000; padding: 6px; vertical-align: middle;">${unit}</td>
        //         <td style="border: 1px solid #000000; padding: 6px; vertical-align: middle;">Tham gia hoạt động sinh hoạt chuyên môn - Phân tích ca bệnh</td>
        //         <td style="border: 1px solid #000000; padding: 6px; vertical-align: middle;">${eventData.tenKhoaDaoTao}</td>
        //         <td style="text-align: center; border: 1px solid #000000; padding: 6px; vertical-align: middle;">${moment(eventData.tuNgay).format('DD/MM/YYYY')}</td>
        //         <td style="text-align: center; border: 1px solid #000000; padding: 6px; vertical-align: middle;">${moment(eventData.denNgay).format('DD/MM/YYYY')}</td>
        //         <td style="border: 1px solid #000000; padding: 6px; vertical-align: middle;">${eventData.diaDiem || ''}</td>
        //         <td style="text-align: center; font-weight: bold; border: 1px solid #000000; padding: 6px; vertical-align: middle;">${eventData.soGioTinChi}</td>
        //     </tr>
        // `;

        var exportItem = {
            id: item.id,
            stt: idx + 1,
            canCuocCongDan: cccd,
            hoTen: fullName,
            donVi: unit,
            hinhThuc: "Tham gia hoạt động sinh hoạt chuyên môn - Phân tích ca bệnh",
            noiDung: eventData.tenKhoaDaoTao,
            tuNgay: moment(eventData.tuNgay),
            denNgay: moment(eventData.denNgay),
            diaDiem: eventData.diaDiem || '',
            soTinChi: eventData.soGioTinChi
        };
        lstExport.push(exportItem);
    });

    var exportItem = {
        id: eventData.id,
        chuDe: eventData.tenKhoaDaoTao,
        chuTri: eventData.chuTri,
        baoCaoVien: eventData.baoCaoVien,
        lstExport: lstExport,
    }

    var model = {
        exportItem: exportItem,
        filePath: filePath,
        fileName: `${moment().format('DD-MM-YYYY_HH-mm-ss-SSS')}_giay_de_nghi_cme`
    }

    var result = await handleExport(model);

    return result;

    // const docHTML = `
    //     <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40">
    //     <head>
    //         <meta charset="utf-8" />
    //         <title>Phụ lục 2</title>
    //         <!--[if gte mso 9]>
    //         <xml>
    //             <w:WordDocument>
    //                 <w:View>Print</w:View>
    //                 <w:Zoom>100</w:Zoom>
    //                 <w:DoNotOptimizeForBrowser/>
    //             </w:WordDocument>
    //         </xml>
    //         <![endif]-->
    //         <style>
    //             @page Section1 {
    //                 size: 29.7cm 21.0cm; /* Landscape A4 */
    //                 margin: 2.0cm 1.5cm 2.0cm 1.5cm;
    //                 mso-header-margin: 36.0pt;
    //                 mso-footer-margin: 36.0pt;
    //                 mso-paper-source: 0;
    //             }
    //             div.Section1 {
    //                 page: Section1;
    //             }
    //             body {
    //                 font-family: "Times New Roman", Times, serif;
    //                 font-size: 13pt;
    //                 line-height: 1.3;
    //             }
    //             table {
    //                 border-collapse: collapse;
    //                 width: 100%;
    //             }
    //             th {
    //                 background-color: #f2f2f2;
    //                 font-weight: bold;
    //                 border: 1px solid #000000;
    //                 padding: 6px;
    //                 font-size: 10.5pt;
    //                 text-align: center;
    //             }
    //             td {
    //                 font-size: 10.5pt;
    //             }
    //         </style>
    //     </head>
    //     <body>
    //         <div class="Section1">
    //             <table style="border: none; width: 100%; margin-bottom: 20px; border-collapse: collapse;">
    //                 <tr style="border: none;">
    //                     <td style="border: none; width: 45%; text-align: center; font-size: 11pt; font-family: 'Times New Roman', Times, serif; vertical-align: top; line-height: 1.2;">
    //                         BỆNH VIỆN TRUNG ƯƠNG QUÂN ĐỘI 108<br/>
    //                         <strong>PHÒNG ĐIỀU DƯỠNG</strong>
    //                     </td>
    //                     <td style="border: none; width: 55%; text-align: center; font-size: 11pt; font-family: 'Times New Roman', Times, serif; vertical-align: top; line-height: 1.2;">
    //                         <strong>Cộng Hoà Xã Hội Chủ Nghĩa Việt Nam</strong><br/>
    //                         <strong>Độc Lập – Tự Do – Hạnh Phúc</strong><br/>
    //                         <span style="font-size: 9pt; letter-spacing: -1px; font-weight: normal; color: #000;">--------------------------</span><br/>
    //                         <span style="font-style: italic; font-size: 11pt; font-weight: normal; display: block; margin-top: 5px;">Hà Nội, ngày ${moment().format('D')} tháng ${moment().format('M')} năm ${moment().format('YYYY')}</span>
    //                     </td>
    //                 </tr>
    //             </table>

    //             <div style="text-align: center; margin-top: 10px; margin-bottom: 20px; font-family: 'Times New Roman', Times, serif;">
    //                 <h3 style="text-align: center; font-weight: bold; margin: 0; font-size: 14pt;">ĐỀ NGHỊ</h3>
    //                 <h3 style="text-align: center; font-weight: bold; margin: 0; font-size: 14pt;">Cấp chứng nhận cập nhật kiến thức y khoa liên tục</h3>
    //                 <div style="text-align: center; font-size: 9pt; letter-spacing: -1px; margin-top: 2px; margin-bottom: 8px;">------------------------------------</div>
    //                 <p style="text-align: center; font-style: italic; font-size: 12pt; margin: 0;">Kính gửi: Phòng Huấn Luyện Đào Tạo</p>
    //             </div>

    //             <div style="font-size: 12pt; font-family: 'Times New Roman', Times, serif; line-height: 1.3; margin-bottom: 15px;">
    //                 Chủ đề: ${eventData.tenKhoaDaoTao || ''}<br/>
    //                 Chủ trì: ${eventData.chuTri || ''}<br/>
    //                 Báo cáo viên: ${eventData.baoCaoVien || ''}
    //             </div>

    //             <p style="font-size: 12pt; font-family: 'Times New Roman', Times, serif; line-height: 1.3; margin-bottom: 15px; text-align: justify;">
    //                 Phòng Điều dưỡng đề nghị Phòng Huấn luyện, đào tạo cấp chứng nhận cập nhật kiến thức y khoa liên tục cho các học viên sau:
    //             </p>
                
    //             <table>
    //                 <thead>
    //                     <tr>
    //                         <th style="width: 4%;">STT</th>
    //                         <th style="width: 11%;">Số CCCD</th>
    //                         <th style="width: 14%;">Họ và tên</th>
    //                         <th style="width: 13%;">Khoa/Phòng</th>
    //                         <th style="width: 16%;">Hình thức</th>
    //                         <th style="width: 16%;">Nội dung</th>
    //                         <th style="width: 8%;">Từ ngày</th>
    //                         <th style="width: 8%;">Đến ngày</th>
    //                         <th style="width: 7%;">Địa điểm</th>
    //                         <th style="width: 3%;">Số tín chỉ</th>
    //                     </tr>
    //                 </thead>
    //                 <tbody>
    //                     ${tableRows}
    //                 </tbody>
    //             </table>
                
    //             <br/>
    //             <table style="border: none; width: 100%;">
    //                 <tr style="border: none;">
    //                     <td style="border: none; text-align: center; width: 50%; font-weight: bold; font-size: 12pt; vertical-align: top;">
    //                         CHỦ TRÌ<br/>
    //                         <span style="font-weight: normal; font-style: italic; font-size: 10pt;">(Ký và ghi rõ họ tên)</span>
    //                     </td>
    //                     <td style="border: none; text-align: center; width: 50%; font-weight: bold; font-size: 12pt; vertical-align: top;">
    //                         THƯ KÝ<br/>
    //                         <span style="font-weight: normal; font-style: italic; font-size: 10pt;">(Ký và ghi rõ họ tên)</span>
    //                     </td>
    //                 </tr>
    //                 <tr style="border: none; height: 70px;">
    //                     <td style="border: none;">&nbsp;</td>
    //                     <td style="border: none;">&nbsp;</td>
    //                 </tr>
    //             </table>
                
    //             <br/>
    //             <p style="font-size: 9.5pt; font-style: italic; margin-top: 15px; margin-bottom: 2px;">(*): Điền theo Quy định của thông tư 32/2023/TT-BYT</p>
    //             <p style="font-size: 9.5pt; font-style: italic; margin-top: 0;">Các đơn vị gửi kèm file word của bảng trên về Phòng Huấn luyện, đào tạo.</p>
    //         </div>
    //     </body>
    //     </html>
    // `;

    // // Tạo blob file Word
    // const blob = new Blob(['\ufeff' + docHTML], { type: 'application/msword;charset=utf-8' });
    // const url = URL.createObjectURL(blob);
    // const a = document.createElement('a');
    // a.href = url;
    // a.download = `${moment().format('DD-MM-YYYY')} Giấy Đề Nghị CME.doc`;
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);
    // URL.revokeObjectURL(url);
    // toast.success("Xuất biểu mẫu Phụ lục 2 (Word) thành công!");
};
